<template>
  <div class="vip-dialog">
    <div class="extend-header"></div>
    <div class="vip-content">
      <span class="mark">特权卡</span>
      <main>
        <div class="title">
         
          会员超值福利
          <span class="title-mark">90%用户下款成功</span>
        </div>
        <div class="content-detail">
          <img :src="require('./images/cotnent.png')" width="100%">
        </div>
      </main>

      <nd-button
        class="btn"
        :class="`caseId-${caseid}`"
        data-sensors-click 
        @click="toDetail"
      >立享特权 </nd-button>
      <div class="give-up" @click="close">放弃好运</div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { setKey, getKey } from '@/assets/utils'

export default {
 
  data () {
    return {
      visible: true,
      time: 3, // 倒计时
      timer: null,
      userInfo: {}
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    caseid: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {},
  watch: {},
  destroyed () {
    clearInterval(this.timer)
  },
  mounted () {
    this.userInfo = getKey('userInfo')
  },
  methods: {
    ...mapActions(['dataPoint']),
    close () {
      this.visible = false
      this.$report({
        id: 50021,
        args: {
          visible: 0,
          target: this.data.activeType,
          step: this.data.nextStep,
          status: 1,
          caseId: this.data.caseId
        }
      })
      this.$emit('close')
    },
    show () {
      setKey('VIP_DIALOG_SHOW_TIME', Date.now())
      this.$report({
        id: 50021,
        args: {
          visible: 1,
          target: this.data.activeType,
          step: this.data.nextStep,
          status: 1,
          caseId: this.data.caseId
        }
      })
    },
    toDetail () {
      this.$report({
        id: 50022,
        args: {
          target: this.data.activeType,
          position: 1,
          status: 1,
          caseId: this.data.caseId
        }
      })
      // 跳转到特权卡中间页面
      this.$router.push({
        path: '/privilege/middle',
        query: {
          from: encodeURIComponent(window.location.href),
          toCard: 'Y'
        }
      })
    }    
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.vip-dialog {
  .extend-header {
    width: 400px;
    height: 150px;
    background: url("./images/img_tanchaungbg.png") no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
  }
  .vip-content {
    width: 620px;
    background: linear-gradient(180deg, #ffffff 0%, #fde8cd 100%);
    border-radius: 30px;
    position: relative;
    overflow: hidden;
    padding-bottom: 40px;
  }
  a {
    color: #8eb2d8;
  }
  .btn {
    width: 440px;
    text-align: center;
    height: 80px;
    background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
    border-radius: 40px;
    text-align: center;
    line-height: 80px;
    font-size: 36px;
    font-weight: 600;
    color: #ffffff;
    margin: auto;
    margin-top: 20px;
  }
  .give-up {
    color: #bb9565;
    line-height: 39px;
    text-align: center;
    margin-top: 12px;
  }
  .mark {
    width: 235px;
    height: 57px;
    line-height: 57px;
    background: linear-gradient(90deg,  #FEF6E4 0%, #FCD5AC 100%);
    position: absolute;
    border-bottom-right-radius: 30px;
    font-weight: 500;
    color: #763E12;
    text-align: center;
  }
  main {
    font-family: PingFangSC-Medium, PingFang SC;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 100px;
    align-items: center;
    padding: 0 40px;
    .title {
      font-size: 54px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 76px;
      position: relative;
      width: 100%;
      text-align: center;
      .title-mark {
        background: linear-gradient(90deg,  #FF3333 0%,#FF5F34 100%);
        color: #fff;
        font-size: 22px;
        position: absolute;
        width:225px;
        height: 42px;
        line-height: 42px;
        padding:0 20px;
        right:0;
        top: -40px;
        border-top-left-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
    .content-detail {
      width: 100%;
      margin-top: 30px;
    }
   
  }
}
</style>
